/** @jsx jsx */
import { jsx } from '@emotion/core';
import get from 'lodash/get';
import { Input } from '../Input';
import { Tooltip } from '../../molecules/Tooltip';
import Error from './Error';
import { labelStyles, Field, FieldBody, Text } from './Field.styles';
import { EditableInput as Props } from './Field.types';

const EditableInput = ({
  label,
  labelWidth,
  autoFocus = false,
  isEditing = true,
  isSubmitting = false,
  value,
  required,
  tag,
  type = 'text',
  size = 'medium',
  stacked = false,
  onChange,
  onBlur,
  textRenderer,
  errors,
  touched,
  toolTip = {},
  placeholder,
  suffix,
}: Props) => {
  const hasError = !!(get(errors, tag) && get(touched, tag));
  return (
    <Field stacked={stacked}>
      {/* eslint-disable-next-line react/no-unknown-property */}
      <label htmlFor={tag} css={labelStyles({ width: labelWidth })}>
        <span>
          {label}&nbsp;
          {required && isEditing && <span data-test-id="required">*</span>}
        </span>
        {toolTip.message && <Tooltip message={toolTip.message!} />}
      </label>
      <FieldBody stacked={stacked} isEditing={isEditing}>
        {isEditing && (
          <Input
            /* eslint-disable-next-line jsx-a11y/no-autofocus */
            autoFocus={autoFocus}
            type={type}
            tag={tag}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            isInactive={isSubmitting}
            size={size}
            hasError={hasError}
            placeholder={placeholder}
            suffix={suffix}
          />
        )}
        {!isEditing && textRenderer == null && <Text>{value}</Text>}
        {!isEditing && textRenderer != null && textRenderer}
        {hasError && <Error error={get(errors, tag, '')} />}
      </FieldBody>
    </Field>
  );
};
export default EditableInput;
